import { Connector } from "./connector"

export enum AutomationProvider {
  Aconex = Connector.Aconex,
  Procore = Connector.Procore,
  Autodesk = Connector.Autodesk,
  Email = "email",
}
